<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="main-wrapper">
        <layouts></layouts>

        <div class="page-wrapper">
            <breadcrumb :title="title" :name="name" :text="text" :text1="text1" />
            
            <verificationOtp />

            <foot />

            <scroll />
        </div>
    </div>
</template>


<script>

export default {
    data() {
        return {
            title: "Verication de code otp",
            text: "Home",
            text1: "Verification",
            name: "/",
        }
    },
}
</script>